import _toConsumableArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './index.css';
import React, { useState } from 'react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { BrightcoveVideoPlayer } from '../BrightcoveVideoPlayer';
import { get, getDictionaryItem, canUseDOM, pathJoin, getDomain } from '../../utils';
import LazyPicture from '../atoms/LazyPicture';
import { ReactComponent as IcPlayWhite } from '../../resources/icons/ic-play-white.svg';
import { ReactComponent as IconPlaylist } from '../../resources/icons/IconPlaylist.svg';
import { ReactComponent as IconPlaylistHover } from '../../resources/icons/IconPlaylistHover.svg';
import { ReactComponent as IconPlaylistMobile } from '../../resources/icons/IconPlaylistMobile.svg';
import { ReactComponent as IconPlaylistMobileHover } from '../../resources/icons/IconPlaylistMobileHover.svg';
import { commonStyles, VideosDropdown, addCustomBreadcrumb } from '../BrightcoveVideosHeader/index';
import Breadcrumbs from "../30_NavigationBar/Breadcrumbs";
import VolumeControl from '../BrightcoveVideosAtoms/VolumeControl';
import { handleAnalitics } from "../../utils/tealium";
import SocialSharingControl from "../BrightcoveVideosAtoms/SocialSharingControl";
import LikeControl from "../BrightcoveVideosAtoms/LikeControl";
import DarkThemeControl from "../BrightcoveVideosAtoms/DarkThemeControl";
import Playlist from '../BrightcoveVideosAtoms/Playlist';
import { formatDate } from '../57_HeaderArticle1/HeaderArticle1';
import { useVideoStructuredData } from '../atoms/Video/useVideoStructuredData';
import useProfile from '../../utils/hooks/useProfile';
var BrightcoveVideoDetailsHeader = function BrightcoveVideoDetailsHeader(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var darkMode = get(sitecoreContext, 'darkMode');
  var themesOfPage = get(sitecoreContext, 'themesOfPage');
  var actions = get(sitecoreContext, 'actions', {});
  var userProfile = useProfile();
  var _actions$changeThemeF = actions.changeThemeFunction,
    changeThemeFunction = _actions$changeThemeF === void 0 ? function () {} : _actions$changeThemeF,
    _actions$setLike = actions.setLike,
    setLike = _actions$setLike === void 0 ? function () {} : _actions$setLike,
    _actions$fetchUserSet = actions.fetchUserSettings,
    fetchUserSettings = _actions$fetchUserSet === void 0 ? function () {} : _actions$fetchUserSet,
    _actions$setVideoVolu = actions.setVideoVolumeFunction,
    setVideoVolumeFunction = _actions$setVideoVolu === void 0 ? function () {} : _actions$setVideoVolu,
    _actions$getLikes = actions.getLikes,
    getLikes = _actions$getLikes === void 0 ? function () {} : _actions$getLikes,
    _actions$setVideoTime = actions.setVideoTimestamp,
    setVideoTimestamp = _actions$setVideoTime === void 0 ? function () {} : _actions$setVideoTime;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    play = _React$useState2[0],
    setPlay = _React$useState2[1];
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var item = get(fields, 'data.contextItem', {});
  var itemId = item.id;
  var season = get(fields, 'data.series.season') || [];
  var seasonName = get(fields, 'data.series.title.jss.value') || '';
  var dictionary = get(fields, 'data.dictionary');
  var playMovieTitle = getDictionaryItem(dictionary, 'play movie') || '';
  var findOutMoreTitle = getDictionaryItem(dictionary, 'find out more') || '';
  var darkModeTitle = getDictionaryItem(dictionary, "dark mode") || '';
  var selectTitle = getDictionaryItem(dictionary, 'selectCategory') || '';
  var episodes = getDictionaryItem(dictionary, 'episodes');
  var episode = getDictionaryItem(dictionary, 'episode');
  var nextVideoLabel = getDictionaryItem(dictionary, 'nextMovie') || 'Next movie';
  var nextLinkGlobal = get(fields, 'data.contextItem.nextVideo.jss') || null;
  var nextMovieID = nextLinkGlobal && get(nextLinkGlobal, 'video.jss.fields.ID.value') || '';
  var shortThousand = getDictionaryItem(dictionary, 'shortThousand') || '';
  var videoId = get(fields, 'data.contextItem.video.jss.fields.ID.value');
  var duration = get(fields, 'data.contextItem.video.jss.fields.Duration.value') || 0;
  var teaserId = get(fields, 'data.contextItem.teaser.jss.fields.ID.value');
  var accountId = get(fields, 'data.videoSetting.publisherID.jss.value');
  var overviewButton = get(fields, 'data.overviewButton.link.jss.value.href');
  var videoGenres = get(fields, 'data.videoGenres.dictionaryValues');
  var mediaVideoUrl = get(sitecoreContext, 'route.fields.Media.value.href');
  var breadcrumb = get(sitecoreContext, 'breadcrumb');
  var breadcrumbAnalytics = get(sitecoreContext, 'breadcrumbAnalytics');
  var _React$useState3 = React.useState(get(sitecoreContext, 'volume', 0)),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    volume = _React$useState4[0],
    _setVolume = _React$useState4[1];
  var teaserMobile = get(fields, 'data.contextItem.teaserMobile.jss.fields.ID.value');
  var isMobile = canUseDOM ? window.matchMedia("(max-width: 768px)").matches : false;
  var title = get(item, 'title.jss.value');
  var category = get(fields, 'data.contextItem.category.targetItem.title.jss.value');
  var analytics = get(fields, 'data.analytics.parameters');
  var videoSocialSharing = get(fields, 'data.videoSocialSharing');
  var videosList = get(sitecoreContext, 'videosList') || [];
  var _React$useState5 = React.useState(null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    videoSetting = _React$useState6[0],
    setVideoSetting = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    openPlaylist = _React$useState8[0],
    setOpenPlaylist = _React$useState8[1];
  var volumeProp = get(sitecoreContext, 'volume');
  var videoIdList = [];
  var _useState = useState(season),
    _useState2 = _slicedToArray(_useState, 2),
    seasonUpdated = _useState2[0],
    setSeasonUpdated = _useState2[1];
  var teaserName = get(fields, 'data.contextItem.name');
  var teaserDesc = get(fields, 'data.contextItem.introText.jss.value', '');
  var publishedDate = get(fields, 'data.contextItem.teaser.jss.fields.PublishedDate.value');
  var teaserImage = get(fields, 'data.contextItem.teaser.jss.fields.ThumbnailURL.value');
  var teaserUrl = get(fields, 'data.contextItem.teaser.jss.url');
  var script = "{\n\t\t\"@context\": \"https://schema.org\",\n\t\t\"@type\": \"VideoObject\",\n\t\t\"name\": \"".concat(teaserName, "\",\n\t\t\"description\": \"").concat(teaserDesc, "\",\n\t\t\"thumbnailUrl\": [\"").concat(teaserImage, "\"],\n\t\t\"uploadDate\": \"").concat(formatDate(publishedDate), "\",\n\t\t\"contentUrl\": \"").concat(pathJoin([getDomain(), teaserUrl]), "\"\n\t}");
  useVideoStructuredData(script);
  season.some(function (s) {
    return s.episode.some(function (e) {
      if (e.video.jss.fields && e.video.jss.fields.ID) videoIdList.push(e.video.jss.fields.ID.value);
    });
  });
  var usePrevious = function usePrevious(value) {
    var ref = React.useRef();
    React.useEffect(function () {
      ref.current = value;
    });
    return ref.current;
  };
  var prevAmount = usePrevious({
    volumeProp: volumeProp
  }) || {};
  /*eslint-disable */
  React.useEffect(function () {
    getLikes([videoId].concat(videoIdList, _toConsumableArray(nextMovieID)));
    fetchUserSettings();
    addCustomBreadcrumb();
    // if(canUseDOM) {
    // 	const urlParams = new URLSearchParams(window.location.search);
    // 	const autoplay = urlParams.get('play');
    // 	autoplay ? setPlay(true): '';
    // }
  }, []);
  React.useEffect(function () {
    // if(prevAmount && prevAmount.volumeProp !== get(sitecoreContext, 'volume')) {
    // 	setVolume(get(sitecoreContext, 'volume'))
    // }
    setVideoSetting(videosList.length ? videosList.filter(function (v) {
      return v.videoId == videoId;
    })[0] : {
      videoId: videoId,
      likes: 0,
      like: false
    });
    var tempSeasonUpdated = seasonUpdated;
    tempSeasonUpdated.some(function (i) {
      i.episode.some(function (e) {
        var a = videosList.find(function (v) {
          if (e.video.jss.fields && e.video.jss.fields.ID) return v.videoId == e.video.jss.fields.ID.value;
        });
        if (a) {
          e.timestamp = a.timestamp;
        }
      });
    });
    setSeasonUpdated(tempSeasonUpdated);
  }, [sitecoreContext]);
  React.useEffect(function () {
    if (canUseDOM) {
      var urlParams = new URLSearchParams(window.location.search);
      var autoplay = urlParams.get('play');
      autoplay ? setPlay(true) : '';
    }
  }, [videoId]);

  /*eslint-disable */

  //setDarkMode(darkMode)
  if (!fields) {
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[BrightcoveVideosHeader component is empty: please provide data source]");
    }
    return null;
  }
  var renderButtonRow = function renderButtonRow(url, name, showButton) {
    var shareURL = canUseDOM ? window.location.pathname : '';
    return /*#__PURE__*/React.createElement("div", {
      className: "brightcoveHeader__item--buttonRow"
    }, /*#__PURE__*/React.createElement("div", {
      className: "brightcoveHeader__item--buttonRow-btn"
    }, videoId && /*#__PURE__*/React.createElement("button", {
      className: "btn btn-primary btn-play m-0",
      onKeyPress: function onKeyPress(event) {
        if (event.key === "Enter" || event.key === "NumpadEnter") {
          event.preventDefault();
          event.target.click();
        }
      },
      onClick: function onClick() {
        setPlay(true);
        handleAnalitics({
          params: params,
          title: name,
          objectParamName: "Play Movie Param",
          objectParams: analytics
        });
      }
    }, /*#__PURE__*/React.createElement(IcPlayWhite, null), " ", /*#__PURE__*/React.createElement("span", null, playMovieTitle))), /*#__PURE__*/React.createElement("div", {
      className: "brightcoveHeader__item--control-btn"
    }, seasonUpdated.length ? /*#__PURE__*/React.createElement("div", {
      tabIndex: 0,
      className: "playlistControl ".concat(openPlaylist ? 'isOpen' : ''),
      onMouseEnter: function onMouseEnter() {
        if (!openPlaylist) setOpenPlaylist(!openPlaylist);
      },
      onMouseLeave: function onMouseLeave() {
        return setOpenPlaylist(!openPlaylist);
      },
      onKeyPress: function onKeyPress(e) {
        if (e.which === 13 || e.which === 32) {
          e.preventDefault();
          setOpenPlaylist(!openPlaylist);
        }
      }
    }, openPlaylist && /*#__PURE__*/React.createElement(Playlist, {
      episodesText: episodes,
      itemId: itemId,
      season: seasonUpdated,
      styles: "".concat(playlistStyles, " ").concat(rtl ? playlistCssRtl : '')
    }), isMobile ? /*#__PURE__*/React.createElement(IconPlaylistMobile, {
      className: 'playlist-icon playlist-icon--mobile'
    }) : /*#__PURE__*/React.createElement(IconPlaylist, {
      className: 'playlist-icon'
    }), isMobile ? /*#__PURE__*/React.createElement(IconPlaylistMobileHover, {
      className: 'playlist-icon-hover playlist-icon-hover--mobile'
    }) : /*#__PURE__*/React.createElement(IconPlaylistHover, {
      className: 'playlist-icon-hover'
    })) : '', shareURL ? /*#__PURE__*/React.createElement(SocialSharingControl, {
      videoSocialSharing: videoSocialSharing,
      shareLink: shareURL,
      analytics: analytics,
      name: name,
      params: params
    }) : null, videoId ? /*#__PURE__*/React.createElement(LikeControl, {
      rtl: rtl,
      shortThousand: shortThousand,
      handleClick: function handleClick() {
        return setLike(videoId);
      },
      count: videoSetting ? videoSetting.likes : 1000,
      like: videoSetting ? videoSetting.like : false,
      analytics: analytics,
      name: name,
      params: params
    }) : null, showButton ? /*#__PURE__*/React.createElement(VolumeControl, {
      setVolume: function setVolume(e) {
        _setVolume(e);
        setVideoVolumeFunction(e);
      },
      volume: volume
    }) : null));
  };
  var renderItems = function renderItems() {
    var fallbackImage = get(item, 'fallbackImage.jss.value');
    var mobileImage = get(item, 'mobileImage.jss.value');
    var imgResult = isMobile && mobileImage && mobileImage.src ? mobileImage : fallbackImage;
    var icon = get(item, 'icon.jss.value');
    var title = get(item, 'title.jss.value');
    var name = get(item, 'name');
    var introText = get(item, 'introText.jss.value');
    var url = get(item, 'url.jss.value');
    return /*#__PURE__*/React.createElement("div", {
      className: "brightcoveHeader__item",
      tabIndex: -1
    }, /*#__PURE__*/React.createElement("div", {
      className: "brightcoveHeader__item--bg"
    }, isMobile && teaserMobile || teaserId ? /*#__PURE__*/React.createElement(BrightcoveVideoPlayer, {
      loop: true,
      autoPlay: true,
      muted: true,
      isPreview: true,
      videoId: isMobile && teaserMobile ? teaserMobile : teaserId,
      accountId: accountId,
      volume: volume,
      changeVolumeFunc: function changeVolumeFunc(e) {
        _setVolume(e);
        setVideoVolumeFunction(e);
      },
      themesOfPage: themesOfPage,
      closeVideo: function closeVideo() {
        return setPlay(false);
      },
      rtl: rtl
    }) : /*#__PURE__*/React.createElement(LazyPicture, null, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      srcSet: imgResult.src
    }), /*#__PURE__*/React.createElement("img", {
      src: imgResult.src,
      alt: imgResult.alt
    }))), /*#__PURE__*/React.createElement("div", {
      className: "brightcoveHeader__item--content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "module-group"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "offset-md-1 col-md-11"
    }, icon && /*#__PURE__*/React.createElement(LazyPicture, null, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      srcSet: icon.src
    }), /*#__PURE__*/React.createElement("img", {
      src: icon.src,
      alt: title
    })), category && /*#__PURE__*/React.createElement("div", {
      className: "brightcoveHeader__item--categories"
    }, /*#__PURE__*/React.createElement("a", {
      href: "".concat(overviewButton, "?category=").concat(encodeURIComponent(category))
    }, /*#__PURE__*/React.createElement("span", null, category))), /*#__PURE__*/React.createElement("h2", null, title), /*#__PURE__*/React.createElement("p", null, introText), renderButtonRow(url, name, isMobile && teaserMobile || teaserId))))));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "brightcoveHeader brightcoveHeader--series"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group brightcoveHeader__controls",
    style: {
      display: play ? 'none' : 'block',
      paddingTop: '0px',
      paddingBottom: '0px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offset-md-1 col-md-8 col-7"
  }, /*#__PURE__*/React.createElement(VideosDropdown, {
    overviewButton: overviewButton,
    videoGenres: videoGenres,
    analytics: analytics,
    params: params,
    label: selectTitle
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3 col-5"
  }, params && params['Dark Mode Switcher Show'] && /*#__PURE__*/React.createElement(DarkThemeControl, {
    handleClick: changeThemeFunction,
    label: darkModeTitle,
    value: darkMode,
    params: params,
    analytics: analytics
  })))),
  //true ?
  play ? /*#__PURE__*/React.createElement(BrightcoveVideoPlayer, {
    autoPlay: true,
    title: title,
    volume: volume,
    videoId: videoId,
    accountId: accountId,
    closeVideo: function closeVideo() {
      return setPlay(false);
    },
    isPreview: false,
    rtl: rtl,
    videoSetting: videoSetting,
    setVideoTimestamp: setVideoTimestamp,
    duration: duration,
    playListObject: {
      episodesText: episodes,
      episodeText: episode,
      itemId: itemId,
      season: seasonUpdated,
      nextLinkGlobal: nextLinkGlobal,
      nextVideoLabel: nextVideoLabel,
      name: seasonName
    },
    themesOfPage: themesOfPage
  }) : renderItems()), isMobile && seasonUpdated && seasonUpdated.length ? /*#__PURE__*/React.createElement(Playlist, {
    episodesText: episodes,
    itemId: itemId,
    season: seasonUpdated,
    styles: "".concat(playlistStylesMobile, " ").concat(rtl ? playlistCssRtl + ' ' + playlistStylesMobileRtl : '')
  }) : '', breadcrumb && /*#__PURE__*/React.createElement(Breadcrumbs, _extends({}, breadcrumb, {
    userProfile: userProfile,
    breadcrumbAnalytics: breadcrumbAnalytics
  })));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    fullWidth: true,
    minHeight: true,
    className: "".concat(commonStyles, " ").concat(ownStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    componentTabIndex: "disabled"
  }, children);
};
var playlistStylesMobile = "prx27an";
var playlistStylesMobileRtl = "pn6u3e5";
export var playlistCssRtl = "pjoghso";
export var playlistStyles = "p1p3o8t2";
var ownStyles = "octwmrz";
var rtlStyles = "rlrf1yu";
var ltrStyles = "l1eqpt28";
export default BrightcoveVideoDetailsHeader;
/*eslint-disable */